

import { QueryRequestProvider } from './footer-details/core/QueryRequestProvider'
import { QueryResponseProvider } from './footer-details/core/QueryResponseProvider'
import { ListViewProvider, useListView } from './footer-details/core/ListViewProvider'
import { KTCard } from '../../../_dashboard/helpers'
import { Footer } from './Footer'

const FooterComponent = () => {
  const {itemIdForUpdate} = useListView()
  return (
    <>
      <KTCard>
     <Footer/>
      </KTCard>
    </>
  )
}

const FooterListWrapper = () => (
  <QueryRequestProvider>
    <QueryResponseProvider>
      <ListViewProvider>
        <FooterComponent />
      </ListViewProvider>
    </QueryResponseProvider>
  </QueryRequestProvider>
)

export {FooterListWrapper}
